// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    background-color: white;
    padding: 15px;
    border-radius: 15px;
    border: 1px solid #e8e8e8;
    /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
    transition: all 0.3s ease;
}

.card {
    display: flex;
    align-items: center;
    /* gap: 15px; */
    padding: 4px;
    justify-content: center;
    flex-wrap: wrap;
    background: white;
    border-radius: 12px;
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); */
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(240, 147, 0, 0.2);
}

.card-img {
    width: 90x;
    height: 120px;
    border-radius: 8px;
    overflow: hidden;
}

.card-text {
    font-size: 14px;
    color: #F09300;
    display: flex;
    align-items: center;
    font-weight: 500;
    transition: color 0.2s ease;
}

.card-text:hover {
    color: #d27f00;
}

a {
    text-decoration: none;  /* Removes the underline */
}

@media (max-width: 768px) {
    .Cards.mobile {
        grid-template-rows: 1fr;
        overflow-x: hidden;
        padding: 10px;
        gap: 15px;
        white-space: nowrap;
        width: auto;
    }

    .card {
        flex-direction: column;
        align-items: flex-start;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }

    .card-img {
        width: 22vw;
        height: auto;
    }

    .card-text {
        font-size: 12px;
        justify-content: center;
        font-weight: bold;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/shopByEditionCard/shopByEditionCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,+CAA+C;IAC/C,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB,GAAG,0BAA0B;AACtD;;AAEA;IACI;QACI,uBAAuB;QACvB,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,aAAa;QACb,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,iBAAiB;IACrB;AACJ","sourcesContent":[".Cards {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n    background-color: white;\n    padding: 15px;\n    border-radius: 15px;\n    border: 1px solid #e8e8e8;\n    /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */\n    transition: all 0.3s ease;\n}\n\n.card {\n    display: flex;\n    align-items: center;\n    /* gap: 15px; */\n    padding: 4px;\n    justify-content: center;\n    flex-wrap: wrap;\n    background: white;\n    border-radius: 12px;\n    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); */\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(240, 147, 0, 0.2);\n}\n\n.card-img {\n    width: 90x;\n    height: 120px;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.card-text {\n    font-size: 14px;\n    color: #F09300;\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    transition: color 0.2s ease;\n}\n\n.card-text:hover {\n    color: #d27f00;\n}\n\na {\n    text-decoration: none;  /* Removes the underline */\n}\n\n@media (max-width: 768px) {\n    .Cards.mobile {\n        grid-template-rows: 1fr;\n        overflow-x: hidden;\n        padding: 10px;\n        gap: 15px;\n        white-space: nowrap;\n        width: auto;\n    }\n\n    .card {\n        flex-direction: column;\n        align-items: flex-start;\n        display: flex;\n        align-items: center;\n        justify-content: space-evenly;\n    }\n\n    .card-img {\n        width: 22vw;\n        height: auto;\n    }\n\n    .card-text {\n        font-size: 12px;\n        justify-content: center;\n        font-weight: bold;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
